import { Alert, darken, Grid2, lighten, styled } from '@mui/material';
import { FC, ReactNode } from 'react';

const Details = styled(Alert)(({ theme }) => ({
    background: theme.palette.mode === 'light'
        ? lighten(theme.palette.primary.main, 0.8)
        : darken(theme.palette.primary.main, 0.5),
    marginBottom: '1.5rem',
    padding: '1.5rem',
    '& *': { fontSize: '1rem' },
    '& > div': { padding: 0 },
    '& > div > div': { marginBottom: '1rem' },
    '& > div > :last-of-type': { marginBottom: 0 },
}));

export interface EConsentTrialDetail {
    label: string;
    value: ReactNode;
}

export interface EConsentTrialDetailsProps {
    details: EConsentTrialDetail[];
}

const EConsentTrialDetails: FC<EConsentTrialDetailsProps> = ({ details }) => (
    <Details icon={false}>
        {details.map(detail => (
            <Grid2 container key={detail.label}>
                <Grid2 size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
                    <strong>{detail.label}</strong>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 8, md: 9, lg: 9, xl: 9 }}>
                    {detail.value}
                </Grid2>
            </Grid2>
        ))}
    </Details>
);

export default EConsentTrialDetails;
